import Vue from 'vue';
import CategoryType from '@/helpers/contentCategory';
import ContentType from '@/helpers/contentType';
import { find } from '@/helpers/tree';
import availabilityConditionalTypes from '@/helpers/availabilityConditionalTypes';
import { ACADEMIC_SYNC_TYPE } from '~/helpers/contentSync';

export default {
  SET_SELECTED_COURSE(state, { context, topics, permissions, associatedAcademicMains, modalConfig }) {
    Vue.set(state.course, 'context', context);
    Vue.set(state.course, 'topics', topics);

    if (permissions) {
      Vue.set(state.course, 'permissions', permissions);
    }
    if (modalConfig) {
      Vue.set(state.course, 'modalConfig', modalConfig);
    }

    Vue.set(state.course, 'associatedAcademicMains', associatedAcademicMains || []);
    Vue.set(state.course, 'hasLocalChanges', false);

    state.course.topics = state.course.topics.map(topic => {
      if (topic.categoryTypeId === CategoryType.ORGANIZATION) {
        return {
          ...topic,
          isEditing: false
        };
      }

      return topic;
    });
  },
  SET_SELECTED_CONTENT(state, params) {
    state.content = params;
  },
  SET_BACKUP_VALUE(state, params) {
    state.backupValue = params;
  },
  CLEAR_SELECTED_CONTENT(state) {
    state.content = {};
  },
  CLEAR_SELECTED_COURSE(state) {
    state.course = {};
  },
  SET_NEW_INDEX_TO_RENDER(state, params) {
    state.selectedIndexToRender = params;
  },
  NEW_MODULE_GROUP(state, params) {
    const index = state.course.topics.findIndex(topic => topic.id === params.children[0].id);


    if (index > -1) {
      state.course.topics.splice(index, 1, params);
    }
  },
  NEW_TOPIC(state, params) {
    if (this.$router.currentRoute.params.id) {
      if (state.content.context.topicId === params.parentTopicId) {
        state.content.topics.push(params);
      }
      if (params.grade && params.grade.gradeBookDetails) {
        params.grade.gradeBookDetails.activity.items.forEach((activity) => {
          const topicReference = state.content.topics.find((topic) => topic.id === activity.topicId);
          topicReference.grade = activity.weight;
        });
      }
    } else {
      if (!params.parentTopicId) {
        if (params.index === 0 || params.index) {
          const itemsToDelete = params.isToReplacePosition ? 0 : 1;

          state.course.topics.splice(params.index, itemsToDelete, params);
          state.course.hasLocalChanges = true;
        } else {
          state.course.topics.push(params);

          if (ContentType.FOLDER !== params.topicTypeId) {
            state.course.hasLocalChanges = true;
          }

          if (params.isMarketplace && ContentType.PAGE === params.topicTypeId) {
            state.course.context.countModulesWithContent = state.course.context.countModulesWithContent + 1;
          }
        }
      } else {
        const index = state.course.topics.findIndex(topic => topic.id === params.parentTopicId);
        if (index > -1) {
          if (state.course.topics[index].children) {
            state.course.topics[index].children.push(params);
          } else {
            Vue.set(state.course.topics[index], 'children', [params]);
          }

          if (params.isMarketplace && ContentType.PAGE === params.topicTypeId) {
            state.course.context.countModulesWithContent = state.course.context.countModulesWithContent + 1;
          }

          state.course.hasLocalChanges = true;
        }
      }
    }
  },
  EDIT_TOPIC(state, params) {
    if (this.$router.currentRoute.params.id) {
      if (params.childrenNewProgressConfigs && params.childrenNewProgressConfigs.length > 0) {
        state.content.topics.forEach(objectChildState => {
          const childToUpdate = params.childrenNewProgressConfigs.find((objectChild)=> objectChild.topicId === objectChildState.id);

          if (childToUpdate) {
            objectChildState.isRecordProgress = childToUpdate.isRecordProgress;
          }
        });
      }

      //updates child objects of a module if the date of the module changes
      if (params.childrenNewDeadlineConfigs && params.childrenNewDeadlineConfigs.length > 0) {
        state.content.topics.forEach(objectChildState => {
          const childToUpdate = params.childrenNewDeadlineConfigs.find((objectChild)=> objectChild.topicId === objectChildState.id);

          if (childToUpdate) {
            objectChildState.deadlineAt = childToUpdate.deadlineAt;
            objectChildState.hasDeadline = childToUpdate.hasDeadline;
            objectChildState.isBeforeDeadline = childToUpdate.isBeforeDeadline;
            objectChildState.parentTopicHasDeadline = childToUpdate.parentTopicHasDeadline;
            objectChildState.parentTopicDeadlineAt = childToUpdate.parentTopicDeadlineAt;
          }
        });
      }
      if (state.content.context.topicId === params.id) {
        Vue.set(state.content.context, 'hasDeadline', params.hasDeadline);
        Vue.set(state.content.context, 'deadlineAt', params.deadlineAt);
        Vue.set(state.content.context, 'isRecordProgress', params.isRecordProgress);
        Vue.set(state.content.context, 'hasGrade', params.hasGrade);
        Vue.set(state.content.context, 'topicTitle', params.title);
        Vue.set(state.content.context, 'isBeforeDeadline', params.isBeforeDeadline);
        Vue.set(state.content.context, 'academicMainDeadlineDate', params.academicMainDeadlineDate);
        Vue.set(state.content.context, 'isAcademicMainExpired', params.isAcademicMainExpired);

        if (state.content.context.categoryTypeId === CategoryType.LINKS) {
          Vue.set(state.content.topics.content, 'items', params.content.items);
        }

        if (state.content.context.categoryTypeId !== CategoryType.ORGANIZATION) {
          Vue.set(state.content.topics.content, 'html', params.content.html);
        }

        if (state.content.topics.hasOwnProperty('design') && params.hasOwnProperty('design')) {
          state.content.topics.design = params.design;
        }

        if (params.hasOwnProperty('hasRubric') && params.hasRubric && params.rubric.id) {
          Vue.set(state.content.topics, 'hasRubric', params.hasRubric);
          Vue.set(state.content.topics, 'rubric', params.rubric);
          Vue.set(state.content.topics, 'isRubricVisibleForStudent', params.isRubricVisibleForStudent);
        } else {
          Vue.set(state.content.topics, 'hasRubric', params.hasRubric);
          Vue.set(state.content.topics, 'rubric', []);
          Vue.set(state.content.topics, 'isRubricVisibleForStudent', params.isRubricVisibleForStudent);
        }

      } else if (params.parentTopicId) {
        if (state.content.context.topicId === params.parentTopicId) {
          const topic = state.content.topics.find(item => item.id === params.id);

          Object.assign(topic, params);

          this.commit('plataforma/newContent/REMOVE_ALL_CONDITIONAL_GRADES_BY_TOPIC_ID', { stateKey: 'content', topicId: params.id });
        }
      } else {
        Object.assign(state.content.topics, params);
      }
      if (params.grade && params.grade.gradeBookDetails) {
        params.grade.gradeBookDetails.activity.items.forEach((activity) => {
          const topicReference = state.content.topics.find((topic) => topic.id === activity.topicId);
          topicReference.grade = activity.weight;
        });
      }
    } else {
      if (!params.parentTopicId) {
        const index = state.course.topics.findIndex((topic) => topic.id === params.id);

        if (index > -1) {
          const backup = JSON.parse(JSON.stringify(Object.assign(state.course.topics[index], params)));
          Vue.set(state.course.topics, index, backup);
        }

        this.commit('plataforma/newContent/REMOVE_ALL_CONDITIONAL_GRADES_BY_TOPIC_ID', { stateKey: 'course', topicId: params.id });
      } else {
        const parentIndex = state.course.topics.findIndex(topic => topic.id === params.parentTopicId);

        if (parentIndex > -1) {
          const parentTopic = state.course.topics[parentIndex].children.find((topic) => topic.id === params.id);

          Object.assign(parentTopic, params);
        }

        this.commit('plataforma/newContent/REMOVE_ALL_CONDITIONAL_GRADES_BY_TOPIC_ID', { stateKey: 'course', parentTopicIndex: parentIndex, topicId: params.id });
      }
    }
  },
  UPDATE_TOPIC(state, params) {
    const index = state.content.content.findIndex(topic => topic.topicId === params.topicId);

    if (index > -1) {
      Vue.set(state.content.content, index, params);
    }
  },
  SET_IS_EDITING_TOPIC(state, index) {
    if (!state.course.topics[index].id) {
      state.course.topics.splice(index, 1);
    } else {
      Vue.set(state.course.topics[index], 'isEditing', !state.course.topics[index].isEditing);
    }
  },
  SET_VERSION(state, version) {
    if (!this.$router.currentRoute.params.id) {
      state.course.context.version = version;
    } else {
      state.content.context.version = version;
    }
  },
  REORDER_TOPIC(state, { newSequence, oldSequence, topic }) {
    if (!topic.parentTopicId) {
      state.course.topics.splice(newSequence, 0, state.course.topics.splice(oldSequence, 1)[0]);
    } else {
      if (!this.$router.currentRoute.params.id) {
        const index = state.course.topics.findIndex(topics => topics.id === topic.parentTopicId);

        if (index > -1) {
          state.course.topics[index].children.splice(newSequence, 0, state.course.topics[index].children.splice(oldSequence, 1)[0]);
        }
      } else {
        const index = state.content.topics.findIndex(topics => topics.id === topic.id);

        if (index > -1) {
          state.content.topics.splice(newSequence, 0, state.content.topics.splice(oldSequence, 1)[0]);
        }
      }
    }
  },
  MOVE_TO_TOPICS(state, { topic, newParentTopicId: parentId, isRollback = false }) {
    const findTopicIndexById = (topics, id) => topics.findIndex(t => t.id === id);

    const moveTopic = (topic, parentId) => {
      const oldParentIndex = findTopicIndexById(state.course.topics, topic.parentTopicId);
      const hasParent = oldParentIndex > -1;
      const oldIndex = findTopicIndexById(
        hasParent ? state.course.topics[oldParentIndex].children : state.course.topics,
        topic.id
      );

      if (oldIndex > -1) {
        const [movedTopic] = hasParent
          ? state.course.topics[oldParentIndex].children.splice(oldIndex, 1)
          : state.course.topics.splice(oldIndex, 1);

        movedTopic.versionAt = null;

        const isOldParentFakeGroupModule = hasParent && movedTopic.id === state.course.topics[oldParentIndex].id;
        if (!isRollback && isOldParentFakeGroupModule) {
          state.course.topics.splice(oldParentIndex, 1);
        }

        const newParentIndex = findTopicIndexById(state.course.topics, parentId);
        if (newParentIndex > -1) {
          const target = state.course.topics[newParentIndex];
          const targetArray = target.children ? target.children : Vue.set(target, 'children', []);
          return targetArray.push({ ...movedTopic, parentTopicId: parentId });
        }

        state.course.topics.push({ ...movedTopic, parentTopicId: parentId });
      }
    };

    const parentIdToUse = typeof parentId === 'undefined' ? null : parentId;

    moveTopic(topic, parentIdToUse);

    Vue.set(state, 'course', { ...state.course });
  },
  CHANGE_TOPIC_TITLE(state, params) {
    if (!this.$router.currentRoute.params.id) {
      const index = state.course.topics.findIndex(topic => topic.id === params.topicId);

      if (index > -1) {
        state.course.topics[index].title = params.title;

        this.commit('plataforma/newContent/SET_IS_EDITING_TOPIC', index);
      }
    } else {
      state.content.context.topicTitle = params.title;
      if (!Array.isArray(state.content.topics)) {
        state.content.topics.title = params.title;
      }
    }
  },
  CHANGE_TOPIC_CONDITIONALS(state, params) {
    if (!this.$router.currentRoute.params.id) {
      const index = state.course.topics.findIndex(topic => topic.id === params.topicId);

      if (index > -1) {
        Vue.set(state.course.topics[index], 'conditionals', params.conditionals);
      }
    } else {
      const index = state.content.topics.findIndex(topic => topic.id === params.topicId);

      if (index > -1) {
        Vue.set(state.content.topics[index], 'conditionals', params.conditionals);
      }
    }
  },
  CHANGE_TOPIC_BANNER(state, params) {
    if (!this.$router.currentRoute.params.id) {
      const index = state.course.topics.findIndex(topic => topic.id === params.topicId);

      if (index > -1) {
        state.content.context.design.bannerDesignId = params.bannerDesignId;
        state.content.context.design.bannerValue = params.bannerValue;
        state.content.context.design.bannerTitle = params.bannerTitle;
        state.content.context.design.bannerTitleDesignId = params.bannerTitleDesignId;
        state.content.context.design.bannerTitleAlignDesignId = params.bannerTitleAlignDesignId;
        state.content.context.design.bannerDetailsColor = params.bannerDetailsColor;

        this.commit('plataforma/newContent/SET_IS_EDITING_TOPIC', index);
      }
    } else {
      state.content.context.design.bannerDesignId = params.bannerDesignId;
      state.content.context.design.bannerValue = params.bannerValue;
      state.content.context.design.bannerTitle = params.bannerTitle;
      state.content.context.design.bannerTitleDesignId = params.bannerTitleDesignId;
      state.content.context.design.bannerTitleAlignDesignId = params.bannerTitleAlignDesignId;
      state.content.context.design.bannerDetailsColor = params.bannerDetailsColor;
    }
  },
  CHANGE_WEBCONFERENCE_INTEGRATION_DATA(state, { topicId, isIntegrated, link, contextId, guestURL }) {
    const webconferenceIntegrationData = { topicId, isIntegrated, link, contextId, guestURL };

    if (!this.$router.currentRoute.params.id) {
      const index = state.course.topics.findIndex(topic => topic.id === topicId);

      if (index > -1) {
        Vue.set(state.course.topics[index], 'content', {
          ...state.course.topics[index].content,
          ...webconferenceIntegrationData
        });

        this.commit('plataforma/newContent/SET_IS_EDITING_TOPIC', index);
      }
    } else if (state.content.topics.length) {
      const index = state.content.topics.findIndex(topic => topic.id === topicId);

      if (index > -1) {
        Vue.set(state.content.topics[index], 'content', {
          ...state.content.topics[index].content,
          ...webconferenceIntegrationData
        });
      }
    } else {
      Vue.set(state.content.topics, 'content', {
        ...state.content.topics.content,
        ...webconferenceIntegrationData
      });
    }
  },
  CHANGE_IS_VISIBLE_TOPIC(state, params) {
    if (!params.topic.parentTopicId) {
      const index = state.course.topics.findIndex(topic => topic.id === params.topic.id);

      if (index > -1) {
        state.course.topics[index].isVisible = !state.course.topics[index].isVisible;
      }
    } else {
      if (!this.$router.currentRoute.params.id) {
        const indexParent = state.course.topics.findIndex(topic => topic.id === params.topic.parentTopicId);

        if (indexParent > -1) {
          const index = state.course.topics[indexParent].children.findIndex(topic => topic.id === params.topic.id);

          if (index > -1) {
            state.course.topics[indexParent].children[index].isVisible = !state.course.topics[indexParent].children[index].isVisible;
          }
        }
      } else {
        const index = state.content.topics.findIndex(topic => topic.id === params.topic.id);

        if (index > -1) {
          state.content.topics[index].isVisible = !state.content.topics[index].isVisible;
        }
      }
    }
  },
  REMOVE_ALL_CONDITIONAL_GRADES_BY_TOPIC_ID(state, { stateKey, topicId, parentTopicIndex = null, isDeletingTopic = false }) {
    const _removeConditionalGradesByTopic = (topic, topicIndex, parentTopicIndex = null) => {
      if (topic.hasConditional && topic.conditionals?.length) {
        const conditionalGradeIndex = topic.conditionals.findIndex((conditional) => conditional.typeId === availabilityConditionalTypes.GRADE);

        if (conditionalGradeIndex > -1) {
          const filteredConditionalGrades = topic.conditionals[conditionalGradeIndex].grades?.filter((conditionalGrade) => conditionalGrade.topicId !== topicId);

          if (parentTopicIndex > -1) {
            Vue.set(state[stateKey].topics[parentTopicIndex].children[topicIndex].conditionals[conditionalGradeIndex], 'grades', filteredConditionalGrades);
          } else {
            Vue.set(state[stateKey].topics[topicIndex].conditionals[conditionalGradeIndex], 'grades', filteredConditionalGrades);
          }
        }
      }
    };

    const modifiedTopic = typeof parentTopicIndex === 'number' && parentTopicIndex > -1
      ? state[stateKey].topics[parentTopicIndex].children.find(topic => topic.id === topicId)
      : state[stateKey].topics.find(topic => topic.id === topicId);

    if (!modifiedTopic.hasGrade || isDeletingTopic) {
      state[stateKey].topics.forEach((topic, topicIndex) => {
        topic.children?.length && topic.children.forEach((child, childIndex) => {
          _removeConditionalGradesByTopic(child, childIndex, topicIndex);
        });

        const currentParentTopicIndex = state[stateKey].topics.findIndex((parentTopic) => parentTopic.id === topic.parentTopicId);
        _removeConditionalGradesByTopic(topic, topicIndex, currentParentTopicIndex);
      });
    }
  },
  DELETE_TOPIC(state, params) {
    if (!params.topic.parentTopicId) {
      this.commit('plataforma/newContent/REMOVE_ALL_CONDITIONAL_GRADES_BY_TOPIC_ID', { stateKey: 'course', topicId: params.topic.id, isDeletingTopic: true });

      const index = state.course.topics.findIndex(topic => topic.id === params.topic.id);

      if (index > -1) {
        if (state.course.topics[index].totalNotCorrected) {
          state.course.context.totalNotCorrected = state.course.context.totalNotCorrected - state.course.topics[index].totalNotCorrected;
        }


        if (params.topic.topicTypeId === ContentType.PAGE && params.topic.hasOwnProperty('children')) {
          state.course.context.countModulesWithContent = state.course.context.countModulesWithContent - 1;
        } else if (params.topic.hasOwnProperty('children')) {
          const modulesWithContent = params.topic.children.filter(module => module.hasOwnProperty('children'));

          state.course.context.countModulesWithContent = state.course.context.countModulesWithContent - modulesWithContent.length;
        }

        state.course.topics.splice(index, 1);
        state.course.hasLocalChanges = true;
      }
    } else {
      if (!this.$router.currentRoute.params.id) {
        if (params.topic.topicTypeId === ContentType.PAGE && params.topic.hasOwnProperty('children')) {
          state.course.context.countModulesWithContent = state.course.context.countModulesWithContent - 1;
        }

        const indexParent = state.course.topics.findIndex(topic => topic.id === params.topic.parentTopicId);

        this.commit('plataforma/newContent/REMOVE_ALL_CONDITIONAL_GRADES_BY_TOPIC_ID', { stateKey: 'course', topicId: params.topic.id, parentTopicIndex: indexParent, isDeletingTopic: true });

        if (indexParent > -1) {
          const index = state.course.topics[indexParent].children.findIndex(topic => topic.id === params.topic.id);

          if (index > -1) {
            if (state.course.topics[indexParent].children[index].totalNotCorrected) {
              state.course.context.totalNotCorrected = state.course.context.totalNotCorrected - state.course.topics[indexParent].children[index].totalNotCorrected;
            }

            state.course.topics[indexParent].children.splice(index, 1);
            state.course.hasLocalChanges = true;
          }
        }
      } else {
        this.commit('plataforma/newContent/REMOVE_ALL_CONDITIONAL_GRADES_BY_TOPIC_ID', { stateKey: 'content', topicId: params.topic.id, isDeletingTopic: true });

        const index = state.content.topics.findIndex((topic) => topic.id === params.topic.id);

        if (index > -1) {
          state.content.topics.splice(index, 1);
          state.course.hasLocalChanges = true;
        }
      }
    }
  },
  SET_IS_CURRENT_VIEWER(state, topicId) {
    if (state.content.topics && state.content.topics.length) {
      state.content.topics = state.content.topics.map(topic => {
        if (topic.id === topicId) {
          return {
            ...topic,
            isCurrentViewer: true
          };
        } else {
          return {
            ...topic,
            isCurrentViewer: false
          };
        }
      });
    }
  },
  TOGGLE_TOPIC_VIEWED(state, params) {
    if (this.$router.currentRoute.params.id) {
      if (state.content.topics && state.content.topics.length) {
        const topic = state.content.topics.find(topic => topic.id === params.topicId);

        if (topic) {
          topic.viewed = params.viewed;
        }
      } else if (state.content.topics && state.content.topics.id === params.topicId) {
        state.content.topics.viewed = params.viewed;
      }
    } else if (state.course.topics && state.course.topics.length) {
      const topic = find(state.course.topics, 'id', params.topicId, 'children');

      if (topic) {
        topic.viewed = params.viewed;

        if (topic.parentTopicId) {
          const parentTopic = find(state.course.topics, 'id', topic.parentTopicId, 'children');
          if (parentTopic && parentTopic.topicTypeId === ContentType.FOLDER && parentTopic.childrenCountWithProgressRecord) {
            parentTopic.viewedChildrenCount = parentTopic.viewedChildrenCount + (params.viewed ? 1 : -1);
            if (parentTopic.viewedChildrenCount === parentTopic.childrenCountWithProgressRecord) {
              parentTopic.expansionStatus = 'completed';
            } else if (parentTopic.viewedChildrenCount > 0) {
              parentTopic.expansionStatus = 'inProgress';
            } else {
              parentTopic.expansionStatus = null;
            }
          }
        }
      }
    }
  },
  UPDATE_AVALIA_ACTIVITY_ATTEMPT_ANSWER(state, params) {
    const _incrementStudentCurrentAttemptFromTopic = (topic) => {
      topic.content.studentCurrentAttempt < topic.content.numberRetries && topic.content.studentCurrentAttempt++;
    };

    if (this.$router.currentRoute.params.id) {
      if (state.content.topics && state.content.topics.length) {
        const topic = state.content.topics.find(topic => topic.id === params.topicId);

        if (topic) {
          _incrementStudentCurrentAttemptFromTopic(topic);
        }
      } else if (state.content.topics && state.content.topics.id === params.topicId) {
        _incrementStudentCurrentAttemptFromTopic(state.content.topics);
      }
    } else if (state.course.topics && state.course.topics.length) {
      const topic = find(state.course.topics, 'id', params.topicId, 'children');

      if (topic) {
        _incrementStudentCurrentAttemptFromTopic(topic);
      }
    }
  },
  UPDATE_QUIZ_ATTEMPT_ANSWER(state, params) {
    if (state.content.context.categoryTypeId === CategoryType.ORGANIZATION) {
      const topic = state.content.topics.find(topic => topic.id === params.topicId);

      topic.content.attempts = params.attempts;
    } else {
      state.content.topics.content.attempts = params.attempts;
    }
  },
  UPDATE_QUIZ_CONTENT(state, params) {
    const validAttempt = params.content.attempts.find(attempt => attempt.isAttemptValid);

    if (state.content.context.categoryTypeId === CategoryType.ORGANIZATION) {
      const topic = state.content.topics.find(topic => topic.id === params.topicId);

      topic.content = params.content;
      topic.viewed = true;

      validAttempt ? topic.studentGrade = validAttempt.grade : topic.studentGrade = params.content.grade;
    } else {
      state.content.topics.content = params.content;
      state.content.topics.viewed = true;

      validAttempt ? state.content.topics.studentGrade = validAttempt.grade : state.content.topics.studentGrade = params.content.grade;
    }
  },
  UPDATE_CONTEXT_TOTAL_UNREAD_MESSAGES(state, params) {
    if (state.course) {
      if (state.course.context.academicMainId.toString() === params.academicMainId.toString()) {
        state.course.context.totalUnreadMessages = params.totalUnreadMessages;
      }
    }
  },
  ADD_LIKE_TOPIC(state, { topicId }) {
    if (this.$router.currentRoute.params.id) {
      if (Array.isArray(state.content.topics)) {
        const index = state.content.topics.findIndex(topic => topic.id === topicId);

        if (index > -1) {
          state.content.topics[index].content.amountLikes++;
          state.content.topics[index].content.isLikedByMe = true;
        }
      } else if (state.content.topics) {
        state.content.topics.content.amountLikes++;
        state.content.topics.content.isLikedByMe = true;
      }
    }
  },
  REMOVE_LIKE_TOPIC(state, { topicId }) {
    if (this.$router.currentRoute.params.id) {
      if (Array.isArray(state.content.topics)) {
        const index = state.content.topics.findIndex(topic => topic.id === topicId);

        if (index > -1) {
          state.content.topics[index].content.amountLikes--;
          state.content.topics[index].content.isLikedByMe = false;
        }
      } else if (state.content.topics) {
        state.content.topics.content.amountLikes--;
        state.content.topics.content.isLikedByMe = false;
      }
    }
  },
  ADD_NEW_POST(state, { topicId }) {
    if (this.$router.currentRoute.params.id) {
      if (Array.isArray(state.content.topics)) {
        const index = state.content.topics.findIndex(topic => topic.id === topicId);

        if (index > -1) {
          if (state.content.topics[index].isToLimitResponses && state.content.topics[index].maxAnswerPerStudent === state.content.topics[index].countOfMyPosts + 1) {
            state.content.topics[index].hasReachedPostLimit = true;
          }

          state.content.topics[index].countPosts++;
          state.content.topics[index].countOfMyPosts++;
        }
      } else if (state.content.topics) {
        if (state.content.topics.isToLimitResponses && state.content.topics.maxAnswerPerStudent === state.content.topics.countOfMyPosts + 1) {
          state.content.topics.hasReachedPostLimit = true;
        }

        state.content.topics.countPosts++;
        state.content.topics.countOfMyPosts++;
      }
    }
  },
  UPDATE_TASK_ATTEMPTS(state, params) {
    if (state.content.topics && state.content.topics.length) {
      const index = state.content.topics.findIndex(topic => topic.id === params.topicId);
      if (index > -1) {
        const indexDraft = state.content.topics[index].content.attempts.findIndex(attempt => attempt.correctionId === params.attempt.correctionId);
        if (indexDraft > -1) {
          state.content.topics[index].content.attempts[indexDraft] = params.attempt;
          state.content.topics[index].content.attempts.splice(indexDraft, 1, params.attempt);
        } else {
          state.content.topics[index].content.attempts.push(params.attempt);
        }
        state.content.topics[index].content.hasCompletedAllAttempts = params.hasCompletedAllAttempts;
        state.content.topics[index].content.isExpectedAnswerVisible = params.isExpectedAnswerVisible;
        if (params.isExpectedAnswerVisible) {
          state.content.topics[index].content.expectedAnswer = params.expectedAnswer;
        }
        if (!params.attempt.isDraft) {
          state.content.topics[index].viewed = true;
        }
      }
    } else {
      const indexDraft = state.content.topics.content.attempts.findIndex(attempt => attempt.correctionId === params.attempt.correctionId);
      if (indexDraft > -1) {
        state.content.topics.content.attempts[indexDraft] = params.attempt;
        state.content.topics.content.attempts.splice(indexDraft, 1, params.attempt);
      } else {
        state.content.topics.content.attempts.push(params.attempt);
      }
      state.content.topics.content.hasCompletedAllAttempts = params.hasCompletedAllAttempts;
      state.content.topics.content.isExpectedAnswerVisible = params.isExpectedAnswerVisible;
      if (params.isExpectedAnswerVisible) {
        state.content.topics.content.expectedAnswer = params.expectedAnswer;
      }
      if (!params.attempt.isDraft) {
        state.content.topics.viewed = true;
      }
    }
  },
  CLEAR_ANSWERS(state, topicId) {
    if (this.$router.currentRoute.params.id) {
      const index = state.content.topics.findIndex((topic) => topic.id === topicId);
      if (index < 0) {
        return;
      }

      state.content.topics[index].wasAnswered = false;
      state.content.topics[index].wasMarkedProgress = false;
      state.content.topics[index].totalNotCorrected = null;
    } else {
      const index = state.course.topics.findIndex((topic) => topic.id === topicId);
      if (index < 0) {
        return;
      }

      if (index > -1) {
        state.course.topics[index].wasAnswered = false;
        state.course.topics[index].wasMarkedProgress = false;
        state.course.topics[index].totalNotCorrected = null;
      }
    }
  },
  CLEAR_ANSWERS_BY_QUESTION_COLLECTION_EXTERNAL_ID(state, questionCollectionExternalId) {
    if (this.$router.currentRoute.params.id) {
      const index = state.content.topics.findIndex((topic) => topic.content?.questionCollectionExternalId === questionCollectionExternalId);
      if (index < 0) {
        return;
      }

      state.content.topics[index].wasAnswered = false;
      state.content.topics[index].wasMarkedProgress = false;
      state.content.topics[index].totalNotCorrected = null;
    } else {
      const index = state.course.topics.findIndex((topic) => topic.content?.questionCollectionExternalId === questionCollectionExternalId);
      if (index < 0) {
        return;
      }

      state.course.topics[index].wasAnswered = false;
      state.course.topics[index].wasMarkedProgress = false;
      state.course.topics[index].totalNotCorrected = null;
    }
  },
  CHANGE_IS_ACTIVE_BY_QUESTION_COLLECTION_EXTERNAL_ID(state, { questionCollectionExternalId, status }) {
    if (this.$router.currentRoute.params.id) {
      const index = state.content.topics.findIndex((topic) => topic.content?.questionCollectionExternalId === questionCollectionExternalId);
      if (index < 0) {
        return;
      }

      Vue.set(state.content.topics[index].content, 'isActive', status);
    } else {
      const index = state.course.topics.findIndex((topic) => topic.content?.questionCollectionExternalId === questionCollectionExternalId);
      if (index < 0) {
        return;
      }

      Vue.set(state.course.topics[index].content, 'isActive', status);
    }
  },
  SET_APPROVAL_FLOW_DATA(state, data) {
    if (!isNaN(Number(data.maxModule))) {
      state.course.context.maxModule = data.maxModule;
    }

    if (data?.approvalFlowStatusId && state.course.context.approvalFlowStatusId !== data?.approvalFlowStatusId) {
      state.course.context.approvalFlowStatusId = data?.approvalFlowStatusId;
    }

    if (data?.comment && !state.course.context.hasComments) {
      state.course.context.hasComments = true;
    }
  },
  CLEAR_EULA(state) {
    state.eula = [];
  },
  SET_EULA_ITEM(state, eula) {
    if (!eula || !eula.providerAlias) {
      return;
    }

    const index = state.eula.findIndex(item => item.providerAlias === eula.providerAlias);

    if (index > -1) {
      state.eula.splice(index, 1, eula);
    } else {
      state.eula.push(eula);
    }
  },
  SET_EULA_ACCEPTED(state, providerAlias) {
    const index = state.eula.findIndex(item => item.providerAlias === providerAlias);

    if (index > -1) {
      state.eula[index].isAccepted = true;
    }
  },
  UPDATE_TOPIC_VERSION_AT_ON_SEQUENCE_CHANGE(state, { oldIndex, newIndex, parentTopicId }) {
    const topics = parentTopicId
      ? state.course.topics.find(t => t.id === parentTopicId).children
      : state.course.topics;

    topics.forEach((topic, index) => {
      if (
        index === oldIndex ||
        index === newIndex ||
        index > newIndex && index < oldIndex ||
        index < newIndex && index > oldIndex
      ) {
        topic.versionAt = null;
        state.course.hasLocalChanges = true;
      }
    });
  },
  SET_TOPIC_VERSION_AT(state, { topicId, value = null }) {
    const syncTypeId = state.course?.context?.academicSyncTypeId;

    if (syncTypeId && syncTypeId === ACADEMIC_SYNC_TYPE.MASTER) {
      const topic = find(state.course.topics, 'id', topicId, 'children');

      if (topic) {
        topic.versionAt = value;
        state.course.hasLocalChanges = true;
      }
    }
  },
  SET_IS_NOTIFY_SYNC_UPDATE_ENABLED(state, { isNotifySyncUpdateEnabled }) {
    if (state.course?.context) {
      state.course.context.isNotifySyncUpdateEnabled = isNotifySyncUpdateEnabled;
    }
  },
  SET_AUTO_GRADE_PENDING(state, pending) {
    state.course.context.autoGrade = {
      ...(state.course.context?.autoGrade ?? {}),
      isPending: pending
    };
  }
};
